export class Overlay {
  constructor(overlay, overlays) {
    this.overlay = overlay;
    if (this.overlay === null) {
      return;
    }
    this.overlays = overlays;
    this.key = this.overlay.dataset.overlay;
    this.openTriggers = document.querySelectorAll('[data-overlay-open="' + this.key + '"]');
    this.closeTriggers = document.querySelectorAll('[data-overlay-close="' + this.key + '"]');
    this.activeClass = 'is-active';
    this.bodyClass = 'has-active-overlay';
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.closeAllOverlays();
        this.open(this.overlay);
      });
    });
    this.closeTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.close(this.overlay);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllOverlays();
      }
    });
  }

  open(overlay) {
    document.body.classList.add(this.bodyClass);
    document.documentElement.classList.add(this.bodyClass);
    overlay.classList.add(this.activeClass);
  }

  close(overlay) {
    document.body.classList.remove(this.bodyClass);
    document.documentElement.classList.remove(this.bodyClass);
    overlay.classList.remove(this.activeClass);
    const closeOverlayEvent = new CustomEvent('closeOverlay', {
      detail: {
        key: overlay.dataset.overlay,
        overlay: overlay,
      }
    });
    overlay.dispatchEvent(closeOverlayEvent);
  }

  closeAllOverlays() {
    this.overlays.forEach((overlay) => {
      if (overlay.classList.contains(this.activeClass)) {
        this.close(overlay);
      }
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  const overlays = document.querySelectorAll('[data-overlay]');
  overlays.forEach((overlay) => {
    new Overlay(overlay, overlays);
  });
});
